import { TwoUIProgressView, TwoUIProgressViewOperationData } from "@amx/ux-twoui-telemetry";
import {
    Stack
} from "@fluentui/react";
import React from "react";
import { Text } from "../../../Text/Text";
import { getSubtextContentStyles } from "../../Dialog.styles";

export interface DialogSubTextOperation {
    /**
     * Operation data for progress view
     */
    readonly progressViewOperationData: TwoUIProgressViewOperationData;

    /**
     * Subtext when operation failed.
     */
    readonly errorSubText?: string;

    /**
     * Subtext when operation success.
     */
    readonly successSubText?: string;

    /**
     * Subtext when operation in progress.
     */
    readonly progressSubText?: string;
}

export interface DialogSubTextProps {
    /**
     * Contains the sub text.
     */
    readonly subText?: string;

    /**
     * Contains operation data.
     */
    readonly operationData?: DialogSubTextOperation;
}

export const DialogSubText: React.FC<DialogSubTextProps> = ({
    subText,
    operationData
}) => {

    const subTextStyleSets = getSubtextContentStyles();

    const subTextContent = (dialogSubTitle?: string) => {
        if (!dialogSubTitle) {
            return (<></>);
        }

        return (
            <Stack className={subTextStyleSets}>
                <Text variant="bodyPrimaryText">
                    {dialogSubTitle}
                </Text>
            </Stack>
        );
    };

    const defaultState = subTextContent(subText);
    const progressState = operationData?.progressSubText ? subTextContent(operationData.progressSubText) : defaultState;

    if (operationData) {

        const errorState = subTextContent(operationData.errorSubText);

        return (
            <TwoUIProgressView
                operationData={operationData.progressViewOperationData}
                inertView={(
                    defaultState
                )}
                firstLoadView={(
                    defaultState
                )}
                updatingView={(
                    progressState
                )}
                updateFailedView={(
                    errorState
                )}
                finishedView={(
                    operationData.successSubText ? subTextContent(operationData.successSubText) : defaultState
                )}
                failedView={(
                    errorState
                )}
            />
        );
    } else {
        return defaultState;
    }
};
